<template>
  <!-- 电费账单 electricityBill-->
  <div class="electricitybill" style="padding: 10px;">
    <div class="con">
      <div class="search-input-btn" style="width:100%">
        <el-scrollbar style="height:100%;width: 100%;">
          <div class="my-search-i">
            <div class="input-small mr-20">
              <span>用户名：</span>
              <el-input v-model="params.ownerName" placeholder="用户名" style="width: 150px;"></el-input>
            </div>
            <div class="input-small mr-20">
              <span>手机号：</span>
              <el-input v-model="params.mobile" placeholder="手机号" style="width: 150px;"></el-input>
            </div>
            <div class="input-small mr-20">
              <span>编号：</span>
              <el-input v-model="params.rfid" placeholder="编号" style="width: 120px;"></el-input>
            </div>
            <div class="input-small myinput-mill mr-20">
              <span>日期类型：</span>
              <el-select v-model="params.queryType" clearable placeholder="请选择">
                <el-option label="月" value="MON"> </el-option>
                <el-option label="日" value="DAY"> </el-option>
              </el-select>
            </div>
            <div class="input-small">
              <span>日期：</span>
              <el-date-picker v-model="params.nowTime" :type="params.queryType=='DAY'?'date':'month'"
                :picker-options="pickerOptions" value-format="timestamp" placeholder="选择日期">
              </el-date-picker>
            </div>
            <el-button type="primary" plain @click="getList" class="search-btn">查询</el-button>
            <el-button type="primary" @click="exportList" class="search-btn">导出excel</el-button>
          </div>
        </el-scrollbar>
      </div>
      <div class="userList-table" :style="{'height':heights+'px'}">
        <el-table ref="table" :data="tableData2" stripe style="width: 100%" :height="heights - 20" row-key="id" border>
          <template slot="empty">
            <span class="noData">
              <img src="@/assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column type="expand">
            <template slot-scope="props">
              <el-table :data="props.row.settlementBills" style="width: 100%" header-row-class-name="tableNest" border
                class="table2" stripe>
                <template slot="empty">
                  <span class="noData">
                    <img src="@/assets/noData.png" alt="暂无数据">
                    <span class="text">暂无数据</span>
                  </span>
                </template>
                <el-table-column label="表号" align="center" prop="deviceNo" min-width="60" />
                <el-table-column label="表名" align="center" prop="deviceName" min-width="180" />

                <el-table-column label="开始时间" align="center" prop="beginTime" min-width="160" />
                <el-table-column label="开始读数" align="center" prop="beginNum" min-width="120" />
                <el-table-column label="结束时间" align="center" prop="endTime" min-width="160" />
                <el-table-column label="结束读数" align="center" prop="endNum" min-width="150" />
                <el-table-column label="总用量" align="center" prop="dosage" min-width="120" />
                <el-table-column label="总金额" align="center" prop="moneyTotal2" min-width="120" />
                <el-table-column label="单价" align="center" prop="unitPrice" min-width="120" />
              </el-table>
            </template>
          </el-table-column>
          <el-table-column label="序号" type="index" align="center" width="50" />
          <el-table-column label="项目名称" align="center" prop="unitName" min-width="150" />
          <el-table-column label="租户名称" align="center" prop="userName" min-width="120" />
          <el-table-column label="租户编号" align="center" prop="userCode" min-width="140" />
          <el-table-column label="手机号" align="center" prop="phone" min-width="140" />
          <el-table-column label="账单类型" align="center" prop="type" min-width="120" />
          <el-table-column label="总金额 " align="center" prop="moneyTotal" min-width="120" />
          <el-table-column label="账单名称" align="center" prop="settlementName" min-width="140" />
        </el-table>
      </div>
      <div class="span" style="position: absolute; opacity: 0;">
        <el-table style="width: 100% " stripe :data="tableData" border id="tabled" :span-method="objectSpanMethod"
          row-key="id">
          <template slot="empty">
            <span class="noData">
              <img src="@/assets/noData.png" alt="暂无数据">
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column label="序号" type="index" align="center" width="50" />
          <el-table-column label="项目名称" align="center" prop="unitName" width="150" />
          <el-table-column label="租户名称" align="center" prop="userName" width="120" />
          <el-table-column label="租户编号" align="center" prop="userCode" width="140" />
          <el-table-column label="手机号" align="center" prop="phone" min-width="140" />
          <el-table-column label="账单类型" align="center" prop="type" width="120" />
          <el-table-column label="总金额 " align="center" prop="moneyTotal" width="120" />
          <el-table-column label="账单名称" align="center" prop="settlementName" width="140" />
          <el-table-column label="电表信息" align="center">
            <el-table-column label="表号" align="center" prop="deviceNo" width="60" />
            <el-table-column label="表名" align="center" prop="deviceName" width="180" />
            <el-table-column label="开始读数" align="center" prop="beginNum" width="120" />
            <el-table-column label="结束读数" align="center" prop="endNum" width="150" />
            <el-table-column label="开始时间" align="center" prop="beginTime" width="160" />
            <el-table-column label="结束时间" align="center" prop="endTime" width="160" />
            <el-table-column label="总用量" align="center" prop="dosage" width="120" />
            <el-table-column label="总金额" align="center" prop="moneyTotal2" width="120" />
            <el-table-column label="单价" align="center" prop="unitPrice" width="120" />
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
  /* eslint-disable */
  let idTmr;
  const getExplorer=() => {
    let explorer=window.navigator.userAgent;
    //ie
    if(explorer.indexOf("MSIE")>=0) {
      return 'ie';
    }
    //firefox

    else if(explorer.indexOf("Firefox")>=0) {
      return 'Firefox';
    }
    //Chrome
    else if(explorer.indexOf("Chrome")>=0) {
      return 'Chrome';
    }
    //Opera
    else if(explorer.indexOf("Opera")>=0) {
      return 'Opera';
    }
    //Safari
    else if(explorer.indexOf("Safari")>=0) {
      return 'Safari';
    }
  }
  // 判断浏览器是否为IE
  const exportToExcel=(data,name) => {

    // 判断是否为IE
    if(getExplorer()=='ie') {
      tableToIE(data,name)
    } else {
      tableToNotIE(data,name)
    }
  }

  const Cleanup=() => {
    window.clearInterval(idTmr);
  }

  // ie浏览器下执行
  const tableToIE=(data,name) => {
    let curTbl=data;
    let oXL=new ActiveXObject("Excel.Application");

    //创建AX对象excel
    let oWB=oXL.Workbooks.Add();
    //获取workbook对象
    let xlsheet=oWB.Worksheets(1);
    //激活当前sheet
    let sel=document.body.createTextRange();
    sel.moveToElementText(curTbl);
    //把表格中的内容移到TextRange中
    sel.select;
    //全选TextRange中内容
    sel.execCommand("Copy");
    //复制TextRange中内容
    xlsheet.Paste();
    //粘贴到活动的EXCEL中

    oXL.Visible=true;
    //设置excel可见属性

    try {
      let fname=oXL.Application.GetSaveAsFilename("Excel.xls","Excel Spreadsheets (*.xls), *.xls");
    } catch(e) {
      print("Nested catch caught "+e);
    } finally {
      oWB.SaveAs(fname);

      oWB.Close(savechanges=false);
      //xls.visible = false;
      oXL.Quit();
      oXL=null;
      // 结束excel进程，退出完成
      window.setInterval("Cleanup();",1);
      idTmr=window.setInterval("Cleanup();",1);
    }
  }

  // 非ie浏览器下执行
  const tableToNotIE=(function() {
    // 编码要用utf-8不然默认gbk会出现中文乱码
    let uri='data:application/vnd.ms-excel;base64,',
      template='<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta charset="UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table border="1">{table}</table></body></html>',
      base64=function(s) {
        return window.btoa(unescape(encodeURIComponent(s)));
      },

      format=(s,c) => {
        return s.replace(/{(\w+)}/g,
          (m,p) => {
            return c[p];
          })
      }
    return (table,name) => {
      let ctx={
        worksheet: name,
        table
      }

      //创建下载
      let link=document.createElement('a');
      link.setAttribute('href',uri+base64(format(template,ctx)));
      link.setAttribute('download',name);
      link.click();
    }
  })()

  // 导出函数
  const export2Excel=(theadData,tbodyData,dataname) => {

    let re=/http/ // 字符串中包含http,则默认为图片地址
    let th_len=theadData.length // 表头的长度
    let tb_len=tbodyData.length // 记录条数
    let width=70 // 设置图片大小
    let height=70

    // 添加表头信息
    let thead='<thead><tr>'
    for(let i=0;i<th_len;i++) {
      if(i%2==0) {
        thead+='<th colspan=2>'+theadData[i]+'</th>'
      } else {
        thead+='<th colspan=4>'+theadData[i]+'</th>'
      }

    }
    thead+='</tr></thead>'

    // 添加每一行数据
    let tbody='<tbody>'
    for(let i=0;i<tb_len;i++) {
      tbody+='<tr>'
      let row=tbodyData[i] // 获取每一行数据

      for(let key in row) {
        if(re.test(row[key])) { // 如果为图片，则需要加div包住图片
          // 
          tbody+='<td style="width:'+width+'px; height:'+height+'px; text-align: center; vertical-align: middle"><div style="display:inline"><img src=\''+row[key]+'\' '+' '+'width='+'\"'+width+'\"'+' '+'height='+'\"'+height+'\"'+'></div></td>'
        } else {
          tbody+='<td style="text-align:center">'+row[key]+'</td>'
        }
      }
      tbody+='</tr>'
    }
    tbody+='</tbody>'


    // 添加尾巴信息
    let foote='<thead><tr>'
    foote+='<th style="text-align:left" colspan=5>'+'运行情况：'+'</th>'
    foote+='<th style="text-align:left" colspan=15>'+''+'</th>'
    foote+='<th style="text-align:left" colspan=5>'+'操作者签名：'+'</th>'
    foote+='<th colspan=3>'+'  年   月   日'+'</th>'
    foote+='</tr></thead>'
    var aa=document.getElementsByTagName('thead')[1]; //头部表头
    var bb=document.getElementsByTagName('tbody')[1]; //列表内容
    let table=aa.innerHTML+bb.innerHTML;
    // 导出表格
    exportToExcel(table,dataname)
  };


  import request from "@/api/http.js";
  export default {
    data () {
      return {
        tableData2: [{
          unitName: "抄表系统",
          userName: "珠宝店",
          userCode: "YT116",
          phone: null,
          id: 1,
          type: "日账单",
          moneyTotal: 17.68,
          settlementName: "2024-05-01日报",
          settlementBills: [{
            deviceNo: 132,
            deviceName: "119",
            beginNum: 6517,
            endNum: 6539.1,
            lastEndNum: null,
            beginTime: "2024-05-01 00:01:21",
            endTime: "2024-05-02 00:01:20",
            dosage: 22.1,
            moneyTotal: 17.68,
            unitPrice: "0.8"
          }]
        },{
          unitName: "抄表系统",
          userName: "餐厅",
          userCode: "HT205206",
          phone: null,
          id: 2,
          type: "日账单",
          moneyTotal: 107.52,
          settlementName: "2024-05-01日报",
          settlementBills: [{
            deviceNo: 100,
            deviceName: "206",
            beginNum: 2,
            endNum: 0,
            lastEndNum: null,
            beginTime: "2024-05-01 00:00:55",
            endTime: "2024-05-02 00:00:54",
            dosage: 0,
            moneyTotal: 0,
            unitPrice: "0.8"
          },{
            deviceNo: 99,
            deviceName: "205",
            beginNum: 32188.8,
            endNum: 32323.2,
            lastEndNum: null,
            beginTime: "2024-05-01 00:00:54",
            endTime: "2024-05-02 00:00:53",
            dosage: 134.4,
            moneyTotal: 107.52,
            unitPrice: "0.8"
          }]
        },{
          unitName: "抄表系统",
          userName: "清漫",
          userCode: "403",
          phone: null,
          id: 3,
          type: "日账单",
          moneyTotal: 0,
          settlementName: "2024-05-01日报",
          settlementBills: []
        },{
          unitName: "抄表系统",
          userName: "青岛啤酒",
          userCode: "YT302",
          phone: null,
          id: 4,
          type: "日账单",
          moneyTotal: 111.84,
          settlementName: "2024-05-01日报",
          settlementBills: [{
            deviceNo: 149,
            deviceName: "136",
            beginNum: 49437,
            endNum: 49576.8,
            lastEndNum: null,
            beginTime: "2024-05-01 00:01:36",
            endTime: "2024-05-02 00:01:35",
            dosage: 139.8,
            moneyTotal: 111.84,
            unitPrice: "0.8"
          }]
        },{
          unitName: "抄表系统",
          userName: "手挞柠檬茶",
          userCode: "B104",
          phone: null,
          type: "日账单",
          id: 5,
          moneyTotal: 41.04,
          settlementName: "2024-05-01日报",
          settlementBills: [{
            deviceNo: 94,
            deviceName: "082",
            beginNum: 11631,
            endNum: 11682.3,
            lastEndNum: null,
            beginTime: "2024-05-01 00:00:50",
            endTime: "2024-05-02 00:00:49",
            dosage: 51.3,
            moneyTotal: 41.04,
            unitPrice: "0.8"
          }]
        }],
        heights: document.getElementById('app').clientHeight-200,//屏幕高度 - 导航栏高度
        params: {
          nowTime: new Date(this.parseTime(new Date(),'{y}-{m}-1')).getTime(),
          queryType: 'DAY', // MON,DAY
          unitId: "",
        },//请求参数
        columnArr: ["a","b","c","d","e","f"],
        spanArr: [], //临时组
        spanData: [], // 组合的合并组
        total: 0,
        columnLabel: [],//头部表头
        optionsName: {
          name: '',
          endTime: '',
          startTime: ''
        },//机组名称
        pickerOptions: {//限制时间选择
          disabledDate (time) {
            return time.getTime()>Date.now();
          },
        },
        conditions: {//传参
          deviceNo: '-111',
          startTime: 1658839022000,
          endTime: 1659271022000,
        },//搜索条件

        tableData: [],
        all_data: [],//总数据
        loading: false,
      };
    },
    computed: {
      nowUnit () {
        return this.$store.unitStore.state.nowUnit
      },
    },
    watch: {
      nowUnit () {
        this.getList();//获取列表数据  
      }
    },

    filters: {
      // 过滤数据
      data_fn (data,a,b) {
        if(data) {
          for(let e=0;e<data.length;e++) {
            const row=data[e];
            if(row.variablename.indexOf(b)!=-1) {
              var key=Object.keys(row)//获取所有key 
              for(let i=1;i<key.length;i++) {
                if(key[i].indexOf(a)!=-1) {//判断时间在value第5的开始位置  
                  return row[key[i]]
                  break
                }
              }
            }
          }
        }

        return '-'
      }
    },
    mounted () {
      this.getList();//获取列表数据  
    },
    methods: {
      objectSpanMethod ({row,column,rowIndex,columnIndex}) {

        if(column.label=="项目名称"||column.label=='租户名称'||column.label=='租户编号'||column.label=='账单类型'||column.label=='总金额 '||column.label=='账单名称') {
          var i=this.spanData.indexOf(rowIndex)
          if(i!=-1&&this.spanData[i+1]) {
            return {
              rowspan: this.spanData[i+1]-this.spanData[i],
              colspan: 1,
            };
          } else {
            return {
              rowspan: 0,
              colspan: 0,
            };
          }
        }
      },

      //获取列表数据
      getList () {
        this.params.unitId=this.nowUnit.id
        var params=this.params;
        this.loading=true

      },


      // 时间格式化
      parseTime (time,cFormat) {
        if(arguments.length===0) {
          return null
        }
        const format=cFormat||'{y}-{m}-{d} {h}:{i}:{s}'
        let date
        if(typeof time==='object') {
          date=time
        } else {
          if((typeof time==='string')&&(/^[0-9]+$/.test(time))) {
            time=parseInt(time)
          }
          if((typeof time==='number')&&(time.toString().length===10)) {
            time=time*1000
          }
          date=new Date(time)
        }
        const formatObj={
          y: date.getFullYear(),
          m: date.getMonth()+1,
          d: date.getDate(),
          h: date.getHours(),
          i: date.getMinutes(),
          s: date.getSeconds(),
          a: date.getDay()
        }
        const time_str=format.replace(/{([ymdhisa])+}/g,(result,key) => {
          const value=formatObj[key]
          // Note: getDay() returns 0 on Sunday
          if(key==='a') {return ['日','一','二','三','四','五','六'][value]}
          return value.toString().padStart(2,'0')
        })
        return time_str
      },
      // 下载excel
      exportList () {
        const tHeader=['开机机组',this.optionsName.name,'开机时间',this.optionsName.startTime||'年 月 日 时 分 ','关机时间',this.optionsName.endTime||'年 月 日 时 分 '];
        // 时间戳
        var timestamp=this.params.nowTime;

        // 创建一个Date对象
        var date=new Date(timestamp);

        // 获取年份
        var year=date.getFullYear();

        // 获取月份（注意月份从0开始，需要加1）
        var month=date.getMonth()+1;

        // 获取日期
        var day=date.getDate();

        // 将月份和日期格式化为两位数
        if(month<10) {
          month='0'+month;
        }
        if(day<10) {
          day='0'+day;
        }

        // 拼接年月日
        var formattedDate=year+'-'+month+'-'+day;
        var monDate=year+'-'+month
        var mystr=""
        if(this.params.queryType=='DAY') {
          mystr=formattedDate
        } else {
          mystr=monDate
        }
        export2Excel(tHeader,[],'财务报表'+mystr);

      },


    }
  };
</script>

<style lang="scss" scoped>
  .table2 {
    /deep/th {
      background-color: #f5f8fa !important;
      color: #000 !important;
    }
  }

  .electricitybill {
    .con {
      width: 100%;
      height: 100%;
      padding: 2px 20px 12px 20px;
      box-sizing: border-box;
      background-color: #fff;

      .myinput-mill {
        /deep/.el-input__inner {
          width: 90px;
        }

        /deep/.el-input {
          width: 90px !important;
        }

      }
    }
  }

  .search {
    margin-bottom: 10px;
    display: flex;
  }

  .search>span {
    display: flex;
    align-items: center;
    margin-right: 15px;
  }

  .tableHeader {
    display: flex;
    border: 1px solid;
    border-bottom: none;
    height: 48px;
    align-items: center;
  }

  .tableHeader div {
    font-size: 16px;
  }

  .tableHeader .n {
    height: 48px;
    line-height: 48px;
    border-right: 1px solid;
    width: 129px;
    text-align: center;
  }

  .home {
    box-sizing: border-box;
    background-color: #e9ebef;
    padding: 10px;
  }

  .el-icon-d-arrow-left {
    position: absolute;
    right: 0;
    top: 300px;
    z-index: 1;
    font-size: 28px;
    cursor: pointer;
    background: #d7d7d7;
    clip-path: polygon(-18px 35px,
        26px 100%,
        calc(100% - 1px) 100%,
        calc(100% - 0px) 0);
    height: 70px;
    line-height: 70px;
    color: #666;
  }

  .el-icon-d-arrow-right {
    position: absolute;
    left: 0;
    top: 300px;
    z-index: 1;
    font-size: 28px;
    cursor: pointer;
    background: #d7d7d7;
    clip-path: polygon(0 0,
        1px 100%,
        calc(100% - 26px) 100%,
        calc(100% - -27px) 31px);
    height: 70px;
    line-height: 70px;
    color: #666;
  }

  .fenye {
    display: flex;
    justify-content: flex-end;
  }
</style>